import React from "react";
import HeroSection from "./components/HeroSection";
import styled from "styled-components";
import Img from './images/1.png'
import Img2 from './images/2.png'
import Img3 from './images/3.png'


const About = () => {



  const data = {
    name: "CartFo Market",
    img: "images/store-1.jpg",
    qoutes: "Cartfo powers millions of businesses worldwide The all-in-one commerce platform to start, run, and grow a business."
  };

  return (
    <>
      <HeroSection myData={data} />

      <Wrapper>

        <div className="about container">
          <h1>Cartfo powers millions of businesses worldwide</h1>
          <br />
          <br />
          <h5> <u>CartFo Story</u> </h5>


          <h2>CartFo Store</h2>
          <p>Over a decade ago, we started a store to sell snowboards online. None of the ecommerce solutions at the time gave us the control we needed to be successful—so we built our own. Today, businesses of all sizes use Cartfo, whether they’re selling online, in retail stores, or on-the-go.</p>
          <h5>Brand of Trust</h5>
          <p>At Cartfo, we passionately believe in keeping our customer's interest on top of everything else. Our day begins and ends with the aim of keeping our customers happy and with that goal in mind we promise you our Band of Trust. Band of Trust comprises of our values with which we aim to consistently deliver a trusted shopping experience to all our customers:</p>

          <div className="grid mt-5 column-1">
            <img src={Img} alt="" />
            <p>On one hand, low prices, other than increasing sales, help the e-commerce to reach a greater potential audience and attract sector of the population with a greater price sensitivity. You will just  have to value the convenience for the brand to incorporate this new target, more difficult to build loyalty. On the other hand, they are a good tool for launching new products. </p>
          </div>

          <div className="grid  mt-5 column-2">
            <p>We strongly believe that a good shopping experience is not fully delivered
              until the products and services sold are competitively priced. Hence, we
              encourage merchants to offer products at the most competitive price</p>
            <img src={Img2} alt="" />
          </div>

          <div className="grid  mt-5 column-1">
            <img src={Img3} alt="" />
            <p>artfo does not permit merchants to sell duplicate, spurious, knockoffs or grey channel items. Merchant guarantee to sell only genuine
              products to customers through Cartfo.com. All Merchants listing their
              products on Cartfo.com are required to enter into an agreement to list.</p>
          </div>



        </div>
      </Wrapper>

    </>
  );
};


const Wrapper = styled.section`
.about{
  p{
    font-size: 1.8rem;
    text-align: justify;
    line-height: 1.7;
  }
  h5{
    font-size:2rem;
    margin-bottom:1rem;
  }
  h2,h1{
    font-weight: 600;
  }

  .column-1{
    grid-template-columns: 0.4fr 2fr;
  }
  .column-2{
    grid-template-columns: 2fr 0.4fr ;
  }
  .grid p{
    margin: auto;
  }
}

`;
export default About;